import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { anyToFloat, calculateTotalHours, CommingSoon, dateDisplayFormater, fnGetFileNameFromContentDispostionHeader, getDateSaveFormat } from "../../../../Utils";
import DatePicker from "react-datepicker";
import Icon from "../../../controls/Icons/Icon";
import DynamicDropdownSearchable from "../../../controls/DynamicDropdownSearchable";
import useFetchWithCancellation from "../../../../customhooks/useFetchWithCancellation";
import ErrorHandler from "../../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import PCPInvoiceMeeting from "./PCPInvoiceMeeting";
import { InvStatusEnum } from "./InvStatusEnum"; 
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";

import { UpdtInvoiceContAction } from "../../../../Reducer/UpdatedInvoiceContentReducer";
import PCPInvoiceMeetingForm from "./PCPInvoiceMeetingForm";
import { InvoiceMeetingAction } from "../../../../Reducer/InvoiceMeetingsReducer";
import DynamicDropdownSearchableForClient from "../../../controls/DynamicDropdownSearchableForClient";
import { PCPAction } from "../../../../Reducer/PCPReducer";
import { useNavigate } from 'react-router-dom';
import InvoiceReport from "../../Invoice/InvoiceReport";
import confirm from "../../../controls/Prompt/useConfirm";
import useConfirm from "../../../controls/Prompt/useConfirm";

function PCPInvoicegenerator() {
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const dispatch = useDispatch();
    const { id } = useParams();

    const [searchParams] = useSearchParams();
    //const { invoiceStatEnum } = InvStatusEnum();
    //invoiceStatEnum.Draft
    const invId = searchParams.get("invid");
    const viewScreen = searchParams.get("view");
    //if (viewScreen == null) viewScreen = false;
    const [isViewScreen, setisViewScreen] = useState(viewScreen);
    const [categories, setCategories] = useState([]);
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0);

    const formRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [error, setError] = useState(null);
    const [isIFInvoice, setisIFInvoice] = useState(false);
    const [isTransInvoice, setisTransInvoice] = useState(false);
    const [InvoiceTypeId, setInvoiceTypeId] = useState(0);
    const [InvoiceOwnerId, setInvoiceOwnerId] = useState(0);
    const [IFAvailableAmt, setIFAvailableAmt] = useState(0);
    const [IFBalanceAmt, setIFBalanceAmt] = useState(0);
    const [IFSpentAmt, setIFSpentAmt] = useState(0);
    const [SavedSuccessfully, setSavedSuccessfully] = useState(false);
    const [manualMeetingId, setManualMeetingId] = useState(0);
    const [invContentupdated, setinvContentupdated] = useState(false);
    const [invFullNumber, setinvFullNumber] = useState("");
    const [invoiceMeetings, setinvoiceMeetings] = useState([]);
    //{
    //    MeetingId: 0,
    //    MeetingDate: "",
    //    Description: "",
    //    TotalHours: "",
    //    Rate: "",
    //    Amount: "",
    //    isManual: false,
    //});

    const [invoiceData, setinvoiceData] = useState([]);
    const [showConfirm, setshowConfirm] = useState(false);
    const [data, setData] = useState({
        fkClientId: id,
        Id: 0,
        ClientName: "",
        FMSName: "",
        RCName: "",
        FMSCoordinator: "",
        RCCoordinator: "",
        UCINumber: "",
        IFAvailableAmt: "",
        IFBalanceAmt: "",
        IFSpentAmt:0,
        InvoiceDate: "",
        InvoiceAmount: "",
        InvoiceNumber: "",
        InvoiceOwnerId: 0,
        InvoiceOwner: "",
        fkRegCarecoordinatorId: "",
        fkregcentid: "",
        fkfmsId: "",
        fkFMScoordinatorId: "",
        InvoiceNotes: "",
        // TotalAmtinWords: "",
        invoiceMeetings: [],
        InvoiceTypeId: 0,
        CreatedDate: "",
        ModifiedDate: "",
        CreatedBy: "",
        ModifiedBy: "",
        isDisabled: true,
        isRateDisabled: true,
    });
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const [isfromEdit, setisfromEdit] = useState(false);
    const { confirm, ConfirmDialog } = useConfirm();
    const handleCloseConfirm = () => setshowConfirm(false);
    
    useEffect(() => {
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
        dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
        dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
        if (!SavedSuccessfully) {
            if (id && id > 0) {
                if (isViewScreen) setissentforApproval(true);
                dispatch({ type: InvoiceMeetingAction.RemoveAllInvoiceMeeting });
                dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
                let Url = "";
                if (invId) {
                    Url = "/Invoice/Get?Id=" + invId;
                    setisfromEdit(true);
                    setData(d => ({ ...d, Id: invId }));
                } else {

                    Url = "/Invoice/GetClientDetailsById?ClientId=" + id;
                    setisfromEdit(false);
                    setData(d => ({ ...d, Id: 0 }));
                }
                // dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
                // setinvContentupdated(!invContentupdated);
                fetchData(state.projectdetail.API + Url, {
                    method: "Get"
                }).then(response => response.json()).then((res) => {

                    if (res) {
                        if (!invId) {
                            if (res.FMSName == "") {
                                window.alert('FMS Name is not available for this client. pleaes update in the client details', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                                let pcpUrl = "/admin/pcpform/" + id + "/personal";
                                navigate(pcpUrl);
                                return false;
                            }
                            if (res.IFBalanceAmt < 0) {
                                //window.alert('The Amount you are trying to invoice is more than the allocated budget in the spending plan(s)', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                                window.alert('You have already spent all the amount or The Amount you are trying to invoice is more than the allocated budget in the spending plan(s)', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                            }
                            res.InvoiceDate = new Date();
                            res.Id = 0;//for new invoice
                            res.InvoiceNotes = "";
                            res.totalAmount = 0;
                           // res.IFSpentAmt = 0;
                            res.InvoiceAmount = 0;
                            res.InvoiceDate = new Date(res.InvoiceDate);
                            res.CreatedDate = new Date(res.CreatedDate);
                            res.ModifiedDate = new Date(res.ModifiedDate);
                            setIFAvailableAmt(res.IFAvailableAmt);
                            setIFSpentAmt(res.IFSpentAmt);
                           // let balanceAmt = res.IFAvailableAmt - res.IFSpentAmt;
                            setIFBalanceAmt(res.IFBalanceAmt);
                           // IFSpentAmt
                            
                            let loggedinUser = JSON.parse(localStorage.getItem("user"));
                            //        setInputValue(c => ({ ...c, invOwnerId: loggedinUser?.Id }));
                            setInvoiceOwnerId(loggedinUser?.Id);
                            setData(res);
                            //if (InvoiceTypeId == "") {
                            //    setInvoiceTypeId("6");
                            //    setisIFInvoice(true);
                            //}
                            setRefresh(!refresh);
                            // setinvoiceDateflg(!invoiceDateflg);
                        } else {
                            
                            if (res.invoiceMaster.InvoiceTypeId === 6 && res.invoiceMaster.FMSName == "") {
                                window.alert('FMS Name is not available for this client. pleaes update in the client details', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                                let pcpUrl = "/admin/pcpform/" + id + "/personal";
                                navigate(pcpUrl);
                                return false;
                            }

                            if (res.invoiceMaster.InvoiceTypeId === 7 && res.invoiceMaster.RCName == "") {
                                window.alert('RC Name is not available for this client. pleaes update in the client details', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                                let pcpUrl = "/admin/pcpform/" + id + "/personal";
                                navigate(pcpUrl);
                                return false;
                            }
                            

                            if (isViewScreen !=null && isViewScreen) {
                                res.invoiceMaster.InvoiceDate = new Date(res.invoiceMaster.InvoiceDate);
                                //if (res.invoiceMaster.InvoiceStatus !== 'Approved') {
                                //    let balanceAmt = (res.invoiceMaster.IFAvailableAmt - (res.invoiceMaster.InvoiceAmount + res.invoiceMaster.IFSpentAmt));
                                //    setIFBalanceAmt(balanceAmt);
                                //} else {
                                //    let balanceAmt = res.invoiceMaster.IFAvailableAmt - res.invoiceMaster.IFSpentAmt
                                //    setIFBalanceAmt(balanceAmt);
                                //}
                            } else {
                                res.invoiceMaster.InvoiceDate = new Date();
                            }
                            
                            data.InvoiceOwnerId = res.invoiceMaster.InvoiceOwnerId;
                            setInvoiceTypeId(res.invoiceMaster.InvoiceTypeId);
                            setInvoiceOwnerId(res.invoiceMaster.InvoiceOwnerId);
                            setIFAvailableAmt(res.invoiceMaster.IFAvailableAmt);
                            setIFBalanceAmt(res.invoiceMaster.IFBalanceAmt);
                            setIFSpentAmt(res.invoiceMaster.IFSpentAmt);
                            //if (res.invoiceMaster.InvoiceStatus !== 'Approved') {
                            //    let balanceAmt = (res.invoiceMaster.IFAvailableAmt - (res.invoiceMaster.InvoiceAmount + res.invoiceMaster.IFSpentAmt));
                            //    setIFBalanceAmt(balanceAmt);
                            //} else {
                            //    let balanceAmt = res.invoiceMaster.IFAvailableAmt - res.invoiceMaster.IFSpentAmt
                            //    setIFBalanceAmt(balanceAmt);
                            //}
                            setinvFullNumber(res.invoiceMaster.InvoiceNumber);
                            setData(res.invoiceMaster);
                            dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
                            setinvContentupdated(!invContentupdated);

                            if (res.invoiceMaster.InvoiceTypeId == 6) {
                                // data.FMSCoordinator = res.Data.CoordinatorName;
                                setisIFInvoice(true);
                                
                                setData(data => ({ ...data, FMSCoordinator: res.invoiceMaster.FMSCoordinator }));
                            } else {
                                setisTransInvoice(true);
                                setData(data => ({ ...data, RCCoordinator: res.invoiceMaster.RCCoordinator }));
                            }

                            for (let i = 0; i < res.invoiceMeetings.length; i++) {
                                res.invoiceMeetings[i].isDisabled = true;
                                res.invoiceMeetings[i].isRateDisabled = true;
                                res.invoiceMeetings[i].isAddedtoInvoice = true;
                                dispatch({ type: UpdtInvoiceContAction.AddUpdtInvoiceContent, payload: res.invoiceMeetings[i] });
                            }
                            setManualMeetingId(res.invoiceMeetings.length);
                             
                        }
                        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: false });
                    }
                    else {
                        window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                    }
                }).catch((err) => {
                    if (err && err.name === 'AbortError') return;
                    window.HandleError("PCPInvoicegenerator.js ==> client Get", null, null, err);
                    console.log(err)
                }).finally(() => {
                    //setLoading(false);
                });
            }
        }

    }, []);

   
    useEffect(() => {
        if (InvoiceTypeId === "6" || InvoiceTypeId === 6) {
            setisIFInvoice(true);
            setisTransInvoice(false);
        }
        else if (InvoiceTypeId === "7" || InvoiceTypeId === 7) {
            setisIFInvoice(false);
            setisTransInvoice(true);
        } else {
            setisIFInvoice(true);
            setisTransInvoice(false);
        }
        setinvoiceData(state.updtInvContent);

    }, [InvoiceTypeId]);
    const handleChange = ((e, rowData) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        if (name == "Rate") {
            if (isNaN(value)) {
                e.target.value = "";
                e.target.focus();
                e.target.disabled = false;
                return false;
            }
        }
        setinvoiceData((invoiceData) =>
            invoiceData.map((row) =>
                row.Id === rowData.Id ? { ...row, Rate: value } : row
            )
        );
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    });

    const handleChangenew1 = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type === "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength >= 0 && value.length > maxLength) {
                return;
            }
        }
        //if (name === "name") {
        //    setInvoiceOwnerId("5");
        //    e.target.options[e.target.selectedIndex].value = "5";
        //   // document.getElementById("InvoiceOwner").selected("5");
        //}
        setData(c => ({ ...c, [name]: value }));
        //dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    });
    const handleDatePickerChange = ((value, name) => {
        let dataObj = { ...data };
        dataObj[name] = value;
        if (name == "InvoiceDate" && !dataObj.InvoiceDate && value) {
            let NewDate = new Date(value);
            NewDate.setFullYear(NewDate.getFullYear() + 1);
            NewDate.setDate(NewDate.getDate() - 1);
            dataObj["InvoiceDate"] = NewDate;
        }
        setData(c => ({ ...c, ...dataObj }));
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    })
    const [selectflag, setselectflag] = useState(false);

    const handleSelect = (rowData, checked, totalAmount) => {
        if (totalAmount > 0) {
            data.totalAmount = totalAmount;
            data.IFBalanceAmt = data.IFAvailableAmt - totalAmount;
        }
        setinvoiceData(state.updtInvContent);
        setselectflag(!selectflag);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    //const [invContentupdated, setinvContentupdated] = useState(false);
    useEffect(() => {
        setinvoiceData(state.updtInvContent);
        setinvContentupdated(!invContentupdated);
    }, [selectflag]);


    const [RateClicked, setRateClicked] = useState(false);
    const [isIFInvSelected, setisIFInvSelected] = useState(false);
    const [RefreshMeetings, setRefreshMeetings] = useState(false);
    const handleInvOwner = (e) => {
        setInvoiceOwnerId(e.target.value);
        setData(data => ({ ...data, InvoiceOwner: e.target.options[e.target.selectedIndex].text }));
        // console.log(InvoiceOwnerId);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }

    const onInvoicetypeChange = (e) => {
        if (e.target.value > 0) {
            // console.log(e.target.options[e.target.selectedIndex].text);
            setInvoiceTypeId(e.target.value);
            if (e.target.options[e.target.selectedIndex].text === "IF Invoice") {
                setisIFInvSelected(true);
                setisTransInvoice(false);
            } else {
                setisIFInvSelected(false);
                setisTransInvoice(true);
            }
            dispatch({ type: UpdtInvoiceContAction.RemoveAllUpdtInvoiceContent });
            data.fkClientId = id;
            setRefreshMeetings(!RefreshMeetings);
            setinvoiceData(state.updtInvContent);
            data.InvoiceAmount = 0;
            data.totalAmount = 0;
            data.MeetingDate = new Date();
            data.InvoiceNotes = "";
            data.Id = 0;
        } else {
            setInvoiceTypeId(0);
            window.alert('Please select Invoice Type', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            return false;
        }
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    const [isRateupdated, setisRateupdated] = useState(false);
    const handleRateupdate = (e, rowData) => {
        const value = e.target.value;
        if (!value) {
            e.target.focus();
            return false;
        }
        if (isNaN(value)) {
            e.target.value = "";
            e.target.disabled = false;
            e.target.focus();
            window.alert('Please enter valid hours');
            //e.target.value = "";
            return false;
        } else {
            rowData.Amount = rowData.Rate * rowData.TotalHours;
            dispatch({ type: UpdtInvoiceContAction.UpdateInvoiceContent, payload: rowData });
            setisRateupdated(!isRateupdated);
            e.target.disabled = true;
        }
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    
    useEffect(() => {
        let totalAmt = 0;
        setinvoiceData(state.updtInvContent);
        // if (data.IFAvailableAmt) {
        invoiceData && invoiceData.length > 0 && invoiceData.map((rowData, rindex) => {
            totalAmt = totalAmt + anyToFloat(rowData.Amount);
        });

        if (invoiceData && invoiceData.length > 0) {
            data.InvoiceAmount = totalAmt;
            let balanceAmt = (IFAvailableAmt - (data.IFSpentAmt + totalAmt));
            setData(data => ({ ...data, IFBalanceAmt: balanceAmt }));
        }
        // }
    }, [isRateupdated, invContentupdated]);

    const [issentforApproval, setissentforApproval] = useState(false);
    const SaveData =async (e, status) => {
        e.preventDefault();
        e.stopPropagation();
       // dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: false });
        if (InvoiceTypeId == 0) {

            window.alert('Please select Invoice Type', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            return false;
        }

        if (!data.InvoiceAmount || data.InvoiceAmount == 0) {
            window.alert("Please Add invoice meeting details");
            dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
            return false;
        }
       
        const isAmtEmpty = invoiceData.some(row => !row.Amount || row.Amount === 0 || row.Amount === '');
        const isMeetDesc = invoiceData.some(row => !row.Description || row.Description === '');
        if (isAmtEmpty || isMeetDesc) {
            window.alert("Please Add invoice meeting details");
            dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
            formRef.current.focus();
            return false;
        }


        //if (IFAvailableAmt < data.InvoiceAmount) {
        //    setshowConfirm(true);
        //    const res = await confirm("Invoice Amount is exceeding the Actual Available Amount. Please check and update the Available Amount. Do you want to Continue?");
        //    if (!res) {
        //        setshowConfirm(false);
        //        return false;
                
        //    }
        //}

       

        //if (isMeetDesc) {
        //    window.alert("Please Add invoice meeting descriptions");
        //   // dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
        //    return false;
        //}
        //if (!isMeetDesc && !isAmtEmpty) {
            let invoiceMasterObj = new Object();
            invoiceMasterObj.Id = data.Id;
            invoiceMasterObj.fkClientId = id;
            invoiceMasterObj.ClientName = data.ClientName;
            invoiceMasterObj.UCINumber = data.UCINumber;
            invoiceMasterObj.InvoiceOwnerId = InvoiceOwnerId;
            invoiceMasterObj.InvoiceNumber = invFullNumber;
            //invoiceMasterObj.InvoiceOwner = data.InvoiceOwner;
            // invoiceMasterObj.FMSName = data.FMSName;
            // invoiceMasterObj.RCName = data.RCName;
            invoiceMasterObj.InvoiceNotes = data.InvoiceNotes;
            invoiceMasterObj.InvoiceDate = getDateSaveFormat(data.InvoiceDate);
            invoiceMasterObj.InvoiceAmount = data.InvoiceAmount;
            //let invTypeId = document.getElementsByName("InvoiceType")[0].value;
            // document.getElementById("InvoiceType")
            invoiceMasterObj.InvoiceTypeId = InvoiceTypeId;
            invoiceMasterObj.fkstatusid = status;
            if (data.Id == 0) {
                invoiceMasterObj.CreatedBy = JSON.parse(localStorage.getItem("user")).Id;
                invoiceMasterObj.ModifiedBy = JSON.parse(localStorage.getItem("user")).Id;
                invoiceMasterObj.CreatedDate = getDateSaveFormat(new Date().toISOString());
                invoiceMasterObj.UpdatedDate = getDateSaveFormat(new Date().toISOString());
            } else {
                invoiceMasterObj.UpdatedDate = getDateSaveFormat(new Date());
                invoiceMasterObj.ModifiedBy = JSON.parse(localStorage.getItem("user")).Id;
                invoiceMasterObj.CreatedDate = data.CreatedDate ?? getDateSaveFormat(new Date().toISOString());
                invoiceMasterObj.CreatedBy = data.CreatedBy ?? JSON.parse(localStorage.getItem("user")).Id;
            }

            if (isIFInvoice) {
                if (!data.fkfmsId && status !== 8) {
                    window.alert("Please Add FMS details to the Client in the Personal data");
                    dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
                    let pcpUrl = "/admin/pcpform/" + id + "/personal";
                    navigate(pcpUrl);
                    return false;
                }

                invoiceMasterObj.CoordinatorName = data.CoordinatorName ?? data.FMSCoordinator;
                invoiceMasterObj.FMSName = data.FMSName;
                invoiceMasterObj.fkfmsId = data.fkfmsId;
                




            }
            if (isTransInvoice) {
                if (!data.RCName) {
                    window.alert("Please Add RC Coordinator details to the Client in the Personal data");
                    dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
                    return false;
                }
                invoiceMasterObj.CoordinatorName = data.CoordinatorName ?? data.RCCoordinator;
                invoiceMasterObj.RCName = data.RCName;
                invoiceMasterObj.fkregcentid = data.fkregcentid;
            }
            // if (!invoiceMasterObj.CoordinatorName) invoiceMasterObj.CoordinatorName = data.FMSCoordinator;
            let objInvMeetings = [];
            setinvoiceData(state.updtInvContent);
            if (!invoiceData || invoiceData.length == 0) {
                window.alert("Please Add invoice meeting details");
                dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
                return false;
            }

        invoiceData && invoiceData.length > 0 && invoiceData.map((rowData, rindex) => {
            if (rowData.MeetingId > 0) {
                if (rowData.Amount > 0) {
                    let invMeetObj = new Object();
                    invMeetObj.fkInvoiceId = data.Id;
                    invMeetObj.MeetingId = rowData.MeetingId;
                    invMeetObj.MeetingDate = getDateSaveFormat(rowData.MeetingDate);
                    invMeetObj.Description = rowData.Description;
                    invMeetObj.TotalHours = rowData.TotalHours;
                    invMeetObj.Rate = rowData.Rate;
                    invMeetObj.Amount = rowData.Amount;
                    invMeetObj.isManual = rowData.isManual;
                    objInvMeetings.push(invMeetObj);
                } else {
                    window.alert("Please Add invoice meeting hours");
                    dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
                    return false;
                }
            }
            });


            let objSave = new Object();

            objSave.InvoiceMaster = invoiceMasterObj;
            objSave.InvoiceMeetings = objInvMeetings;
        setLoading(true);
       // setissentforApproval(true);
            fetchData(state.projectdetail.API + "/invoice/save", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(objSave)
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    res.Data.InvoiceDate = new Date(res.Data.InvoiceDate)
                    res.Data.CreatedDate = new Date(res.Data.CreatedDate);
                    res.Data.CreatedBy = invoiceMasterObj.CreatedBy;
                    setIFAvailableAmt(data.IFAvailableAmt);
                    res.Data.IFBalanceAmt = data.IFAvailableAmt - (res.Data.InvoiceAmount + res.Data.IFSpentAmt);

                    data.Id = res.Data.Id;
                    setData(res.Data);
                    if (isIFInvSelected) {
                        // data.FMSCoordinator = res.Data.CoordinatorName;
                        setData(data => ({ ...data, FMSCoordinator: res.Data.CoordinatorName }));
                    }
                    if (isTransInvoice) {
                        setData(data => ({ ...data, RCCoordinator: res.Data.CoordinatorName }));
                    }
                    if (res.Data.fkstatusid != 8) {
                        setissentforApproval(true);
                        setisViewScreen(false);
                    }

                    //reset InvoiceforAction Count
                    fetch(state.projectdetail.API + "/invoice/GetInvoiceCountByStatus?status=Sent for Approval", {
                        method: "Get"
                    }).then(response => response.json()).then((res) => {
                        if (res > 0) {
                            dispatch({ type: "ADDINVCNTFORACTION", payload: res });
                        }
                        else {
                            dispatch({ type: "ADDINVCNTFORACTION", payload: 0 });
                            // window.alert('Something went wrong', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                        }

                    }).catch((err) => {
                        if (err && err.name === 'AbortError') return;
                        window.HandleError("InvoiceGenearator.js ==> Invoice generator", null, null, err);
                        console.log(err)
                    }).finally(() => {
                        setLoading(false);
                       // setissentforApproval(false);
                    });

                    window.toast("Invoice saved sucessfully");
                    setValidated(false);
                    setSavedSuccessfully(true);
                    dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: false });
                    navigate("/admin/invoice");

                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("PCPInvoicegenerator.js ==> client save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
            });
       // }

    }

    const handleSendforApproval = (e, status) => {
       // console.log("handleSendforApproval");
       // console.log("status:" + status);
        // SaveData(e,"Approval");
    };
    const handleEdit = (e, id) => {
        document.getElementById(id).disabled = false;
        document.getElementById(id).focus();
    };

    const handleEditnew = (e, rowData) => {
        if (rowData.isManual) {
            setinvoiceData(prevData =>
                prevData.map(item =>
                    item.Id === rowData.Id ? { ...item, isDisabled: !item.isDisabled,isRateDisabled:!item.isRateDisabled } : item
                )
            );
        }
        if (!rowData.isManual) {
            setinvoiceData(prevData =>
                prevData.map(item =>
                    item.Id === rowData.Id ? { ...item, isRateDisabled: !item.isRateDisabled } : item
                )
            );
            let rateId = "Rate_" + rowData.Id;
            document.getElementById(rateId).focus();

        }
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    };

    const handleChangenew = (e, rowData) => {
        let name = e.target.name;
        let value = e.target.value;
        if (!value) {
             e.target.focus();
           
            setinvoiceData(prevData =>
                prevData.map(item =>
                    item.Id === rowData.Id ? { ...item, [name]: value } : item
                ));
            return false;
        }
        setinvoiceData(prevData =>
            prevData.map(item =>
                item.Id === rowData.Id ? { ...item, [name]: value } : item
            )
        );
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    const HandleAddInvoiceContent = () => {
        setShowModal(true);
    }
    
    const AddManualinvContent = (res) => {
        // window.alert(res);
        // console.log(res);
       // console.log(state.updtInvContent);
        setManualMeetingId(manualMeetingId + 1);
        let resObj = {
            ...res, Id: manualMeetingId + 1
        };
        // console.log(resObj);
        const parseLocalDate = (dateString) => {
            const [y, m, d] = dateString.split("-");
            return new Date(y, m - 1, d);
        };
        const meetdate = parseLocalDate(resObj.MeetingDate);

        meetdate.setDate(meetdate.getDate() + 1);
        let currInvCnt = ({
            Id: manualMeetingId + 1,
            Description: resObj.Description,
            Rate: resObj.Rate,
            Amount: resObj.Amount,
            TotalHours: resObj.TotalHours,
            isManual: resObj.isManual,
            MeetingDate: meetdate,
            isDisabled: false,
            isRateDisabled: false,
            isDelEnabled:true,
        });
        dispatch({ type: UpdtInvoiceContAction.AddUpdtInvoiceContent, payload: currInvCnt });
        setinvoiceData(state.updtInvContent);
        setShowModal(false);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    };

    const AddManualinvCont = (res) => {
        if (InvoiceTypeId == 0) {
            window.alert('Please select Invoice Type', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            return false;
        }
        setManualMeetingId(manualMeetingId + 1);
       
        let currInvCnt = ({
            Id: manualMeetingId + 1,
            MeetingId: manualMeetingId + 1,
            Description: "",
            Rate: 100,
            Amount: "",
            TotalHours: "",
            isManual: true,
            MeetingDate: new Date(),
            isDisabled: false,
            isRateDisabled: false,
        });
        dispatch({ type: UpdtInvoiceContAction.AddUpdtInvoiceContent, payload: currInvCnt });
        setinvoiceData(state.updtInvContent);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
       
    };
    const [isDeleteInvCont, setisDeleteInvCont] = useState(false);
    const handleDelInvCont = (rowData) => {
        dispatch({ type: UpdtInvoiceContAction.RemoveUpdtInvoiceContent, payload: rowData.MeetingId });
       // setinvoiceData(state.updtInvContent);
        setisDeleteInvCont(!isDeleteInvCont);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
        
    };

    useEffect(() => {
        setinvoiceData(state.updtInvContent);
        handleTotalAmt();
    }, [isDeleteInvCont]);

    const handleTotalAmt = () => {
       // setinvoiceData(state.updtInvContent);
        var totalAmt = 0;
        state.updtInvContent && state.updtInvContent.length > 0 && state.updtInvContent.map((rowData, rindex) => {
            totalAmt = totalAmt + anyToFloat(rowData.Amount);
        });
        if (invoiceData && invoiceData.length > 0) {
            data.InvoiceAmount = totalAmt;
            data.totalAmount = totalAmt;
            let balanceAmt = (IFAvailableAmt - data.InvoiceAmount);
            setData(data => ({ ...data, IFBalanceAmt: balanceAmt }));
        }
    };
    const handleDescription = (e) => {
        if (!e.target.value) {
            e.target.focus();
            return false;
        } else {
            e.target.disabled = true;
        }
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    const [ShowInvReport, setShowInvReport] = useState(false);
    const [invoiceNumber, setinvoiceNumber] = useState("");
    const handleViewInvoice = () => {
       // console.log("Invoice Number : " + data.InvoiceNumber);
        //navigate("/admin/invoiceforapproval/InvoiceReport");
        // navigate("/admin/invoiceforapproval/InvoiceReport");
        setinvoiceNumber(data.InvoiceNumber);
        setShowInvReport(true);
    }
    const [isDownloading, setisDownloading] = useState(false);
    const handleDownloadInvoice = async() => {
        let invId = data.Id;
        if (data.Id > 0) {
            setisDownloading(true);
            setProgress(0);
            const response = await fetch(state.projectdetail.API + "/invoicePDF/GeneratePDF?id=" + invId, {
                method: "GET",
            });
            const contentLength = response.headers.get("Content-Length");
            const total = contentLength ? parseInt(contentLength, 10) : null;

            const reader = response.body.getReader();
            let received = 0;
            const chunks = [];

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                chunks.push(value);
                received += value.length;

                if (total) {
                    setProgress(Math.round((received * 100) / total));
                }
            }
            //const response = await fetchData(state.projectdetail.API + "/invoicePDF/GeneratePDF?id =" + data.Id, {
            //    method: "Get"
            //});

            if (!response.ok) {
                throw new Error("Download failed");
            }
            if (response !== undefined) {

                const blob = new Blob(chunks);
                const url = URL.createObjectURL(blob);
                //const blob = await response.blob();

                //const url = window.URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                //a.download = "sample.pdf";
                var fileName = data.InvoiceNumber + ".pdf";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                a.remove();
                window.URL.revokeObjectURL(url);
                setisDownloading(false);
            }
        }
    }
    const CloseInvReport = () => {
        setShowInvReport(false);
    }
    const handleinvMeetdate = (e,rowData) => {
        if (e) {
            //setinvoiceData(prevData => {
            //    prevData.map(item => item.invId === rowData.invId ? { ...item, MeetingDate: e } : item)
            //});

            setinvoiceData(prevData =>
                prevData.map(item =>
                    item.Id === rowData.Id ? { ...item, MeetingDate: e } : item
                ));
           // rowData.MeetingDate = e;
        }
    }

    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <Row className="mb-2">
                <Col md={3}>
                    {!isfromEdit && !isViewScreen &&
                        <h5 className="d-inline-block">Create Invoice </h5>
                    }
                    {isfromEdit && !isViewScreen &&
                        <h5 className="d-inline-block">Modify Invoice </h5>
                    }
                    {isfromEdit && isViewScreen &&
                        <h5 className="d-inline-block">View Invoice </h5>
                    }
                </Col>
                <Col md={5}>
                   
                </Col>

                <Col md={4}>
                    {isfromEdit &&
                        <h6> Invoice Number : { invFullNumber}     </h6>
                    }
                </Col>
               
            </Row>
            {error ? <ErrorHandler error={error} /> :
                loading ? <div className="text-center"><Spinner className='dropdown-loading' as="span" animation="border" size="lg" role="status" aria-hidden="true" /></div> :
                    <div>
                        <Row className="mb-2">
                            <Col>
                                <Card className="border ">
                                    <Card.Body>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Label>Invoice Type:<code className='required-symbol'>*</code></Form.Label>
                                                {isfromEdit && !isViewScreen && (
                                                    <DynamicDropdownSearchable className="form-control"
                                                        name="InvoiceType"
                                                        id="InvoiceType"
                                                        defaultval={InvoiceTypeId}
                                                        onDropdownChange={onInvoicetypeChange}
                                                        disabled={isfromEdit}
                                                        required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=InvoiceType"}
                                                        label="Description" value="Id" fetchType="get"
                                                    />)}

                                                {isfromEdit && isViewScreen && (
                                                    <DynamicDropdownSearchable className="form-control"
                                                        name="InvoiceType"
                                                        id="InvoiceType"
                                                        defaultval={InvoiceTypeId}
                                                        onDropdownChange={onInvoicetypeChange}
                                                        disabled={isViewScreen}
                                                        required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=InvoiceType"}
                                                        label="Description" value="Id" fetchType="get"
                                                    />)}


                                                {!isfromEdit && !isViewScreen && (
                                                    <DynamicDropdownSearchable className="form-control"
                                                        name="InvoiceType"
                                                        id="InvoiceType"
                                                        onDropdownChange={onInvoicetypeChange}
                                                        disabled={isViewScreen}
                                                        required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=InvoiceType"}
                                                        label="Description" value="Id" fetchType="get"
                                                    />)}
                                                {validated && !InvoiceTypeId && <div><small className="text-danger">Please select Invoicetype</small></div>}
                                            </Col>
                                            {isIFInvoice &&
                                                <Col md={2}>
                                                    <Form.Group>
                                                        <Form.Label>Available Amount</Form.Label>
                                                        <Form.Control type="text" name="IFAvailableAmt" value={IFAvailableAmt} disabled autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                            }
                                            {isIFInvoice &&
                                                <Col md={2}>
                                                    <Form.Group>
                                                        <Form.Label> Spent Amount</Form.Label>
                                                        <Form.Control type="text" name="IFSpentAmt" value={IFSpentAmt} disabled autoComplete="off" />
                                                        {/*{!invId   &&( //data.IFSpentAmt&& */}
                                                        {/*    <Form.Control type="text" name="IFSpentAmt" value={IFSpentAmt} disabled autoComplete="off" />*/}
                                                        
                                                        {/*)}*/}
                                                        {/*{invId && (*/}
                                                        {/*    <Form.Control type="text" name="IFSpentAmt" value={IFSpentAmt} disabled autoComplete="off" />*/}
                                                        {/*)}*/}
                                                    </Form.Group>
                                                </Col>
                                            }
                                            {isIFInvoice &&
                                            <Col md={2}>
                                                <Form.Group>
                                                        <Form.Label> Balance Amount</Form.Label>
                                                        {IFBalanceAmt > 0 &&
                                                            <Form.Control type="text" name="IFBalanceAmt" value={IFBalanceAmt} disabled autoComplete="off" />
                                                        }
                                                        {IFBalanceAmt < 0 &&
                                                            <Form.Control type="text" style={{ color: 'red' }} name="IFBalanceAmt" value={IFBalanceAmt} disabled autoComplete="off" />
                                                        }
                                                </Form.Group>
                                            </Col>
                                            }       
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>Invoice Date<code className='required-symbol'>*</code></Form.Label>
                                                    <DatePicker required={true} className="form-control" selected={data.InvoiceDate} onChange={(val) => (handleDatePickerChange(val, "InvoiceDate"))}
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        dateFormat="MM-dd-yyyy"
                                                    />
                                                    {validated && !data.InvoiceDate && <div><small className="text-danger">Please select Invoice Date</small></div>}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                         
                                            <Row>
                                            {isIFInvoice &&
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>FMS </Form.Label>
                                                        <Form.Control type="text" name="FMSName" value={data.FMSName} defaultval={data.FMSName} disabled autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                            }

                                            {isTransInvoice &&
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>RC</Form.Label>
                                                        <Form.Control type="text" name="RCName" value={data.RCName} disabled autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                            }
                                            {isIFInvoice &&
                                                <Col md={2}>
                                                    <Form.Group>
                                                        <Form.Label>Service Co-Ordinator</Form.Label>
                                                        <Form.Control type="text" name="FMSCoordinator" value={data.FMSCoordinator} disabled autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                            }
                                            {isTransInvoice &&
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Service Co-Ordinator</Form.Label>
                                                        <Form.Control type="text" name="RCCoordinator" value={data.RCCoordinator} disabled autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                            }

                                            <Col md={3}>
                                                <Form.Label>Invoice Owner</Form.Label>
                                                <DynamicDropdownSearchableForClient
                                                    from={state.projectdetail.API + "/User/GetAllActiveUsers"}
                                                    label="name"
                                                    value="Id"
                                                    fetchType="get"
                                                    name="name"
                                                    id="name"
                                                    disabled={isViewScreen }
                                                    onDropdownChange={handleInvOwner}
                                                    defaultval={InvoiceOwnerId}
                                                   />
                                            </Col>
                                            
                                            </Row>
                                       
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <div>
                            {/*{!isTransInvoice && (isfromEdit &&*/}
                            {isfromEdit &&
                                <PCPInvoiceMeeting afterSelect={handleSelect} ClientId={id} InvoiceId={invId} refresh={RefreshMeetings} isfromEdit={isfromEdit} isViewOnly={isViewScreen} InvoiceTypeId={InvoiceTypeId}>
                                </PCPInvoiceMeeting>
                            }
                            {/*{!isTransInvoice && (!isfromEdit &&*/}
                            { !isfromEdit &&
                                <PCPInvoiceMeeting afterSelect={handleSelect} ClientId={id} InvoiceId={data.Id} refresh={RefreshMeetings} isViewOnly={isViewScreen} InvoiceTypeId={InvoiceTypeId}>
                                </PCPInvoiceMeeting>
                            }

                        </div>
                        <div>
                            <h5>Invoice Content</h5>
                            
                  <Row className="mb-2">
                   <Col>
                    <Card className="border ">
                                        <Card.Body>
                                            <Row>
                                                <Col md={10}>
                                                </Col>
                                                <Col md={2}>
                                                    <Button type="button" onClick={AddManualinvCont} className="me-2" disabled={ isViewScreen} variant="primary">Add Manual Meeting</Button>
                                                </Col>
                                            </Row>
                                    <Row>
                                        <Col>
                                            <Table responsive className="table">
                                                <thead>
                                                <tr>
                                                <th md={1}>Sl.No</th>
                                                <th md={2}>Date</th>
                                                <th md={3}>Description</th>
                                                <th md={1}>Total Hours</th>
                                                <th md={1}>Rate</th>
                                                <th md={1}>Amount</th>
                                                <th md={1}>Edit</th>
                                                <th md={1}>Delete</th>
                                                <th md={1}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                            {invoiceData && invoiceData.length > 0 && invoiceData.map((rowData, rindex) => {
                                                               
                                                                return (rowData.MeetingDate && (
                                                    <tr key={rindex+1}>
                                               <td>
                                                            {rindex + 1}  
                                                        </td>
                                                        {!isViewScreen && rowData.isManual &&
                                                            <td md={2}>
                                                                <DatePicker style={{ width: "100px" }} required={true} name="MeetingDate" selected={new Date(rowData.MeetingDate)} onChange={(e) => (handleinvMeetdate(e, rowData))}
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    dateFormat="yyyy-MM-dd"
                                                                    disabled={rowData.isDisabled}
                                                                />
                                                            </td>
                                                        }

                                                        {!isViewScreen && !rowData.isManual &&
                                                            <td md={2}>
                                                                <input type={Text} id={`txt_${rowData.Id}`} name="MeetingDate" key={rowData.Id}
                                                                    onChange={(e) => { handleChangenew(e, rowData) }}
                                                                    onBlur={(e) => { handleDescription(e) }}
                                                                    value={rowData.MeetingDate.split("T")[0]} disabled={rowData.isDisabled}></input>
                                                            </td>
                                                        }

                                                        {isViewScreen  &&
                                                            <td md={2}>
                                                                <input type={Text} id={`txt_${rowData.Id}`} name="MeetingDate" key={rowData.Id}
                                                                    onChange={(e) => { handleChangenew(e, rowData) }}
                                                                    onBlur={(e) => { handleDescription(e) }}
                                                                    value={rowData.MeetingDate.split("T")[0]} disabled={rowData.isDisabled}></input>
                                                            </td>
                                                        }

                                                        {/*{isViewScreen && */}
                                                        {/*    <td md={2}>*/}
                                                        {/*        <DatePicker required={true} className="form-control" selected={new Date(rowData.MeetingDate)} onChange={(val) => (handleDatePickerChange(val, "MeetingDate"))}*/}
                                                        {/*            showYearDropdown*/}
                                                        {/*            showMonthDropdown*/}
                                                        {/*            dateFormat="MM-dd-yyyy"*/}
                                                        {/*        />*/}
                                                        {/*    </td>*/}
                                                        {/*}*/}

                                                        <td>
                                                            <input type={Text} id={`txt_${rowData.Id}`} name="Description" key={rowData.Id}
                                                                onChange={(e) => { handleChangenew(e, rowData) }}
                                                                onBlur={(e) => {handleDescription(e) } }
                                                                value={rowData.Description} disabled={rowData.isDisabled}></input>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                            <input type={Text} id={`txt_${rowData.Id}`} name="TotalHours"
                                                                onChange={(e) => { handleChangenew(e, rowData) }}
                                                                onBlur={(e) => handleRateupdate(e, rowData)}
                                                               // onMouseUp={(e) => handleRateupdate(e, rowData)}
                                                                value={rowData.TotalHours} disabled={rowData.isRateDisabled} ></input>
                                                        </td>
                                                        <td> $
                                                            <input type={Text} id={`Rate_${rowData.Id}`} name="Rate"
                                                                onChange={(e) => { handleChange(e, rowData) }}
                                                                onBlur={(e) => handleRateupdate(e, rowData)}
                                                               // onMouseUp={(e) => handleRateupdate(e, rowData)}
                                                                value={+rowData.Rate} disabled={rowData.isRateDisabled}
                                                              
                                                            ></input>
                                                            
                                                        </td>
                                                        <td>
                                                            ${rowData.Amount}
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {state.access.edit ? <Button variant="link"
                                                                    text="Edit" tooltip="Edit"
                                                                    className="btn-xs p-0"
                                                                    disabled={isViewScreen }
                                                                    //onClick={(e) => { handleEdit(e, rowData) }}>
                                                                    onClick={(e) => { handleEditnew(e,rowData) }}>
                                                                <Icon title="Spending Plan" name="BsPiggyBankFill" className='fs-5' />
                                                            </Button> : ""}
                                                        </div>
                                                        </td>
                                                        {/*{rowData.isManual && !rowData.isAddedtoInvoice &&*/}
                                                       
                                                        {rowData.isManual && data.fkstatusid === 8 && data.invId > 0 &&
                                                            //console.log("inv status ID : " + data.fkstatusid )
                                                            <div> 
                                                                {state.access.edit ? <Button variant="link"
                                                                    className="btn-xs p-0" style={{ color: 'red' }}
                                                                    onClick={() => handleDelInvCont(rowData)}
                                                                >
                                                                    <Icon name="BsTrash" className='fs-5' />
                                                                </Button> : ""}
                                                            </div>
                                                        
                                                        }

                                                        {rowData.isManual && !data.invId && !isViewScreen &&

                                                            <div>
                                                                  {state.access.edit ? <Button variant="link"
                                                                    className="btn-xs p-0" style={{ color: 'red' }}
                                                                    onClick={() => handleDelInvCont(rowData)}
                                                                >
                                                                    <Icon name="BsTrash" className='fs-5' />
                                                                </Button> : ""}
                                                            </div>

                                                        }
                                                </tr>  
                                                )
                                                   )}
                                                )
                                            }
                                           <tr></tr>
                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td><b>Total Amount</b></td>
                                                                <td>$<input type="text" style={{ align: 'center' }} disabled name="InvoiceAmount" value={data.InvoiceAmount}></input></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                            </Row>
                            <Row>
                            </Row>
                            {/*<Row>*/}
                                
                            {/*    <Col md={9}></Col>*/}
                            {/*    <Col md={2} style={{align:'left'}} ><b>Total Amount:</b></Col>*/}
                            {/*     <Col md={1} style={{ align: 'center' }}>    <input type="text" style={{align:'center'}} disabled name="InvoiceAmount" value={data.InvoiceAmount}></input></Col>*/}
                            {/*    */}{/*<Col md={3}></Col>*/}
                            {/*</Row>*/}
                            <Row>
                                <Col md={8}>
                                    {/*<input type="text" name="TotalAmtinWords" value={data.TotalAmtinWords} onChange={(e) => { handleChangenew(e) }}></input>*/}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    {/*<Form.Group>*/}
                                    {/*    <Form.Label>Invoice Notes:</Form.Label>*/}
                                    {/*                    <Form.Control as="textarea" row={2} name="InvoiceNotes" disabled={isViewScreen} value={data.InvoiceNotes} onChange={(e) => { handleChangenew(e) }} autoComplete="off" />*/}
                                                    {/*</Form.Group>*/}


                                </Col>
                            </Row>
                                            {/*<Row className="mb-2">*/}
                                            {/*    {data.InvoiceNumber &&*/}
                                            {/*        <Button*/}
                                            {/*            className="btn-xs me-2 mb-2 p-0" variant="link"*/}
                                            {/*            onClick={handleViewInvoice}*/}
                                            {/*        >Click Here to View Invoice</Button>*/}
                                            {/*    }*/}
                                            {/*</Row>*/}
                                           
                            <Row className="mb-2"></Row>
                                            <Row className="mb-2"> <Col md={1}></Col>
                                                <Col md={4}> {data.InvoiceNumber &&
                                                    <Button
                                                        className="btn-xs me-2 mb-2 p-0" variant="link"
                                                        onClick={handleViewInvoice}
                                                    >Click Here to View Invoice</Button>
                                                }</Col>
                                <Col md={3}></Col>
                                <Col md={4}>
                                            
                                 </Col>
                                            </Row>

                                            <Row className="mb-2"> <Col md={1}></Col>
                                                <Col md={4}> {data.InvoiceNumber && data.fkstatusid !== InvStatusEnum.Draft && 
                                                    data.fkstatusid !== InvStatusEnum.SentforApproval &&
                                                    data.fkstatusid !== InvStatusEnum.Rejected &&
                                                    data.fkstatusid !== InvStatusEnum.Returned &&(
                                                    <Button
                                                        className="btn-xs me-2 mb-2 p-0" variant="link"
                                                        onClick={handleDownloadInvoice}
                                                    >Click Here to Download Invoice</Button>
                                                    )}</Col>
                                                {isDownloading &&
                                                    <Col md={3}>{data.InvoiceNumber && data.fkstatusid !== InvStatusEnum.Draft &&
                                                        data.fkstatusid !== InvStatusEnum.SentforApproval &&
                                                        data.fkstatusid !== InvStatusEnum.Rejected &&
                                                        data.fkstatusid !== InvStatusEnum.Returned && (
                                                            <div>Download Progress: {progress}%</div>)}
                                                    </Col>
                                                }
                                                <Col md={4}>

                                                </Col>
                                            </Row>
                                            <Row className="mb-2"> <Col md={1}></Col>
                                                <Col md={4}> </Col>
                                                <Col md={3}></Col>
                                                <Col md={4}>
                                                    <Button type="button" id="Save"
                                                        disabled={issentforApproval}
                                                        name="Save"
                                                        onClick={(e) => { SaveData(e, InvStatusEnum.Draft) }} className="me-2" variant="primary">Save to Draft</Button>
                                                    &nbsp;&nbsp;
                                                    <Button type="button"
                                                        onClick={(e) => { SaveData(e, InvStatusEnum.SentforApproval) }}
                                                        className="me-2"

                                                        disabled={issentforApproval}
                                                        variant="primary">Send for Approval</Button>

                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Modal show={showModal} onHide={handleClose} size="lg" backdrop="static">
                                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                    <h4>Add Invoice content </h4>
                                    <CloseButton onClick={handleClose} className="btn-close" />
                                </Modal.Header>
                                <Modal.Body>
                                    <PCPInvoiceMeetingForm afterSave={AddManualinvContent} _inputValue={data} onCancel={handleClose} refresh={refresh} isViewOnly={isViewScreen } />
                                </Modal.Body>
                            </Modal>

                            <Modal size="lg" show={ShowInvReport} onHide={CloseInvReport} backdrop="static">
                                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                    <h4>Invoice :  {invoiceNumber}</h4>
                                    <CloseButton onClick={CloseInvReport} className="btn-close" />
                                </Modal.Header>
                                <Modal.Body>
                                    <InvoiceReport _inputValue={invId} _invNumber={invoiceNumber} onCancel={CloseInvReport} />
                                </Modal.Body>
                            </Modal>

                            <Modal show={showConfirm} onHide={handleCloseConfirm} className="confirm-message" centered backdrop="static">
                                {/*<Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">*/}
                                {/*    */}{/*<h4>Add Invoice content </h4>*/}
                                {/*    <CloseButton onClick={handleCloseConfirm} className="btn-close" />*/}
                                {/*</Modal.Header>*/}
                                <Modal.Body>
                                    {ConfirmDialog}
                                    {/*<PCPInvoiceMeetingForm afterSave={AddManualinvContent} _inputValue={data} onCancel={handleClose} refresh={refresh} isViewOnly={isViewScreen} />*/}
                                </Modal.Body>
                            </Modal>

                        </div>
                        </div>

                       
            }
        </Form>
    </ErrorBoundary>
    )
}
export default (PCPInvoicegenerator);